import QuotesGroup from "../../../engagements/details/sections/quote-history/quotes-group"
import { QuotesGroupSkeleton } from "../../../skeletons"
import {
  DEFAULT_DATETIME_DAY_FORMAT,
  formatDateTimeFromMillis
} from "../../../../utils"

type Props = {
  event: { created: number } | undefined
  quoteId?: number
  isFetching: boolean
  cards?: any[]
  loanAmount: number
  onSelect: (id: string) => void
}

export default function MostRecentQuoteSection({
  event,
  quoteId,
  isFetching,
  cards,
  loanAmount,
  onSelect
}: Props) {
  if (!event) return null
  return (
    <div className="py-3">
      <time className="font-bold text-lg pb-4">
        {formatDateTimeFromMillis(
          event.created * 1000,
          DEFAULT_DATETIME_DAY_FORMAT
        )}
      </time>
      {isFetching ? (
        <QuotesGroupSkeleton cardCount={4} />
      ) : cards ? (
        <QuotesGroup
          quoteId={quoteId?.toString() ?? ""}
          timestamp={event.created}
          cards={cards}
          loanAmount={loanAmount}
          onSelect={onSelect}
          hideTitle
        />
      ) : (
        <div className="py-4 text-neutral-500">
          Could not load quote data for this entry.
        </div>
      )}
    </div>
  )
}
